export default "__VITE_ASSET__1fGznak2__"